export default __webpack_public_path__ + "static/media/flayer9.ad8de337.jpg";